import * as React from "react";
import { YoungAdultsMenu } from "../../components/pageComponents/Menus/YoungAdultMenu";
import Content from "./Shirts";

export default function YoungAdultsContent() {
  return (
    <>
      <YoungAdultsMenu />
      <Content />
    </>
  );
}
